import type { TypographyStyle } from '@/components/atoms/typography/typography';

const variables: { subHeadlineTagStyle: TypographyStyle } = {
  subHeadlineTagStyle: 'bodyLargeBold',
};

export default variables;
